module.exports = __webpack_public_path__ + "c09fa74fa9da36396ae11d45c94a2262.ttf";